import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "knudeerstat",
  "use": "knudeerstat-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" id=\"knudeerstat\"><path d=\"M25.92 8.87v1h-4.65a8.07 8.07 0 0 0-13 0H3.71v-1H1.47v9.72h2.06v-1h3.7a8.08 8.08 0 0 0 15.08 0h3.43v1H28V8.87z\" fill=\"#6d6e71\" stroke=\"#6d6e71\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".5\" /><circle cx=\"21.63\" cy=\"15.15\" r=\"6.88\" fill=\"#da9c28\" /><path d=\"M22.47 13v5.46h-1.69V13h-1.94v-1.2h5.57V13z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/knudeerstat.svg
// module id = uJSK
// module chunks = 1